module.exports = __webpack_public_path__ + "img/loke.0b321a2f.png";